import { Link } from '@amzn/awsui-components-core';
import React, { useContext } from 'react';
import constants from '../../../../../common/constants';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { InputFormField } from './InputFormField';
import {
  inputLengthValidation,
  openSourceReviewUrlAllowedPathValidation,
  requiredFieldValidation,
  validUrlValidation,
} from './Validations';

export const OpenSourceReviewUrlFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);
  const validations = [
    requiredFieldValidation,
    validUrlValidation,
    inputLengthValidation,
    openSourceReviewUrlAllowedPathValidation,
  ];
  const description = (
    <>
      <Link href="https://w.amazon.com/bin/view/Open_Source/Open_Sourcing/" external variant="info">
        {constants.CODE_REPO_OS_REVIEW_INFO_LINK_1}
      </Link>{' '}
      {constants.CODE_REPO_OS_REVIEW_INFO_TEXT_1}
    </>
  );
  const updateOpenSourceReviewUrl = (newValue: string) => ({ openSourceReviewUrl: newValue });

  return (
    <InputFormField
      fieldId="os_review_url"
      description={description}
      validations={validations}
      label="Open source review URL*"
      value={repoData.openSourceReviewUrl}
      setValue={updateOpenSourceReviewUrl}
    />
  );
};
